import axios from 'axios';
import * as environment from '../../../environment';
import { currentEnvironment } from '../../../helpers';

export interface StripeClientSecretData {
  success: boolean;
  data: {
    data: {
      paymentIntent: {
        client_secret: string;
      };
    };
  };
}

export interface StripeClientSecretResponse {
  response: StripeClientSecretData | null;
  error: any;
}

export const stripeClientSecretAxios = async (
  cartId: number
): Promise<StripeClientSecretResponse> => {
  const application = currentEnvironment();

  const externalGateway = environment.envApolloUrls[application].external;

  let error = null;
  let response = null;

  try {
    response = (await axios.get(
      `${externalGateway}/v1/stripe/payment_intents?cartId=${cartId}`
    )) as StripeClientSecretData;
  } catch (errorResponse) {
    error = errorResponse;
  }

  return { response, error };
};
